import { render, staticRenderFns } from "./Login_star.vue?vue&type=template&id=5f47d927&scoped=true"
import script from "./Login_star.vue?vue&type=script&lang=js"
export * from "./Login_star.vue?vue&type=script&lang=js"
import style0 from "./Login_star.vue?vue&type=style&index=0&id=5f47d927&prod&lang=css"
import style1 from "./Login_star.vue?vue&type=style&index=1&id=5f47d927&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f47d927",
  null
  
)

export default component.exports